/**
 * Sorts roles by seniority: Owner, Editor, Viewer, then alphabetically
 */
export function sortRolesBySeniority(
  roles: Array<{ mrn: string; title: string }>,
): Array<{ mrn: string; title: string }> {
  const roleOrder: Record<string, number> = {
    owner: 0,
    editor: 1,
    viewer: 2,
  };

  return [...roles].sort((a, b) => {
    const aTitle = a.title.toLowerCase();
    const bTitle = b.title.toLowerCase();

    const aOrder = roleOrder[aTitle] ?? 999;
    const bOrder = roleOrder[bTitle] ?? 999;

    if (aOrder !== bOrder) {
      return aOrder - bOrder;
    }

    // Both are "other" roles, sort alphabetically
    return a.title.localeCompare(b.title);
  });
}
